import { Box, styled } from '@mui/material';

const COLORS = {
  critical: 'error',
  high: 'warning',
  medium: 'info',
  low: 'success',
};

const Wrapper = styled(Box)`
  display: flex;
  align-items: center;

  cursor: pointer;

  & p {
    font-size: 0.9rem;
    font-weight: 800;
    color: ${({ theme, priority }) => theme.palette?.[COLORS?.[priority]].main ?? 'inherit'};
  }

  & svg {
    margin-right: 0.2rem;
    color: ${({ theme, priority }) => theme.palette?.[COLORS?.[priority]].main ?? 'inherit'};
  }
`;

export default Wrapper;
